import { useReadContract } from 'wagmi';
import { ERC20_ABI } from '../config/contracts';

export const useTokenAllowance = (tokenAddress, ownerAddress, spenderAddress) => {
  const { data: allowance, isLoading, refetch } = useReadContract({
    address: tokenAddress,
    abi: ERC20_ABI,
    functionName: 'allowance',
    args: [ownerAddress, spenderAddress],
    watch: true
  });

  return {
    allowance: allowance || 0n,
    isLoading,
    refetch,
    hasAllowance: (amount) => allowance && allowance >= amount
  };
};
